import React from 'react';

import handShakeIcon from 'images/partners/hand-shake.svg';

const PartnerHeader = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center sm:items-start my-40 sm:my-48 px-16 sm:px-28">
      <img src={handShakeIcon} className="sm:mr-32 mb-8 sm:mb-0 py-6" />
      <div>
        <h1 className="text-headline-xl text-center sm:text-left text-primary-black font-serif m-0">
          Partners
        </h1>
        <p className="mt-16 sm:mt-24 mb-0 text-primary-black font-serif body-lg sm:text-[1.5rem] max-w-full md:max-w-[78%]">
          We welcome working with companies to help them access our journalism and reach our
          subscribers with high-quality messages.
        </p>
      </div>
    </div>
  );
};

export default PartnerHeader;
